import type { CityConfig } from "../city-template/types";

export const wilsonConfig: CityConfig = {
  city: "Wilson",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "wilson",
  route: "/wilson",
  title: "Emergency Passport Wilson, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wilson, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wilson County and eastern North Carolina. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Wilson, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Wilson and Wilson County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wilson%20North%20Carolina%20downtown%20at%20golden%20hour%20with%20historic%20brick%20buildings%20and%20the%20Whirligig%20Park%2C%20charming%20southern%20town%20square%20with%20tree-lined%20streets%20and%20restored%20architecture%2C%20warm%20sunset%20light%20over%20Wilson%20County%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20small-town%20elegance%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=wilson-hero-nc-001&orientation=landscape",
  heroImageAlt: "Wilson North Carolina downtown with historic Whirligig Park at golden hour in Wilson County",
  geoPosition: "35.7213;-77.9155",
  geoPlacename: "Wilson, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 270 miles north of Wilson — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Elm City", zips: "27822" },
    { name: "Lucama", zips: "27851" },
    { name: "Saratoga", zips: "27873" },
    { name: "Black Creek", zips: "27813" },
    { name: "Stantonsburg", zips: "27883" },
    { name: "Kenly", zips: "27542" },
    { name: "Smithfield", zips: "27577, 27578" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Nashville", zips: "27856" },
    { name: "Goldsboro", zips: "27530, 27531, 27532, 27533, 27534" },
    { name: "Greenville", zips: "27834, 27835, 27836, 27858" },
    { name: "Kinston", zips: "28501, 28502, 28503, 28504" },
    { name: "Raleigh", zips: "27601, 27602, 27603, 27604, 27605, 27606, 27607, 27608, 27609, 27610, 27612, 27613, 27614, 27615, 27616, 27617, 27623, 27695, 27697, 27698, 27699" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wilson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Eastern NC Hub", desc: "Serving Wilson, Rocky Mount, Greenville, and all of Wilson County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Rocky Mount, NC", route: "/rocky-mount" },
    { name: "Emergency passport help in Greenville, NC", route: "/greenville" },
    { name: "Urgent passport services in Goldsboro, NC", route: "/goldsboro" },
    { name: "Passport courier services in Durham, NC", route: "/durham" },
    { name: "Same-day passport help in Fayetteville, NC", route: "/fayetteville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wilson remotely via secure courier. We do not have a walk-in office in Wilson — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wilson County and eastern North Carolina travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wilson County and eastern North Carolina",
  serviceAreaIntro: "From downtown Wilson's historic Whirligig Park to the Elm City suburbs, from the Saratoga countryside to the Stantonsburg crossroads — Fast Passport Center serves the entire Wilson region. We regularly help travelers from Rocky Mount, Nashville, Goldsboro, Greenville, Kinston, Smithfield, and Raleigh get their passports fast.",
  nearbyCitiesIntro: "We serve all Wilson neighborhoods and the surrounding eastern North Carolina area including Elm City, Lucama, Saratoga, Black Creek, Stantonsburg, Kenly, Smithfield, Rocky Mount, Nashville, Goldsboro, Greenville, Kinston, and Raleigh. If you are anywhere in Wilson County or eastern North Carolina, we have you covered.",
  howItWorksIntro: "Most Wilson travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Wilson travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Wilson and Wilson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wilson? Here are the most common ones we hear from Wilson County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Wilson international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Wilson, NC",
      rating: 5,
      text: "My passport expired 4 days before a business trip to Germany. Fast Passport Center had my renewal processed and back to me in 32 hours. The dedicated agent kept me informed every step of the way.",
      service: "Passport Renewal",
    },
    {
      name: "Robert T.",
      location: "Elm City, NC",
      rating: 5,
      text: "Emergency passport for a family cruise out of Miami. Got it in 27 hours. Incredible service for a small town like Elm City. No way I could have driven to Atlanta in time.",
      service: "Emergency Passport",
    },
    {
      name: "Angela C.",
      location: "Lucama, NC",
      rating: 5,
      text: "First passport for my daughter before a school trip to Italy. Fast Passport Center made it easy. Had her passport in 4 days. The document review caught a photo issue before it was submitted.",
      service: "Child Passport",
    },
    {
      name: "Steven B.",
      location: "Rocky Mount, NC",
      rating: 5,
      text: "Lost my passport 6 days before a conference in Tokyo. Fast Passport Center had a replacement in 30 hours. Best decision I made for my Wilson County travel needs.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "wilson-1",
      name: "Wilson Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2800 Ward Blvd",
      city: "Wilson",
      state: "NC",
      zip: "27893",
      phone: "(252) 237-0131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wilson facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "wilson-2",
      name: "Rocky Mount Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "219 N Church St",
      city: "Rocky Mount",
      state: "NC",
      zip: "27801",
      phone: "(252) 446-6141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northeast of Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for Wilson east side residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "wilson-3",
      name: "Smithfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "218 E Market St",
      city: "Smithfield",
      state: "NC",
      zip: "27577",
      phone: "(919) 934-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles southwest of Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston County and western Wilson County. Good alternative for Wilson south side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wilson-4",
      name: "Goldsboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Center St",
      city: "Goldsboro",
      state: "NC",
      zip: "27530",
      phone: "(919) 736-0131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles southeast of Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wayne County. Alternative for Wilson southeast residents.",
      icon: "ri-mail-line",
    },
    {
      id: "wilson-5",
      name: "Greenville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2210 W Arlington Blvd",
      city: "Greenville",
      state: "NC",
      zip: "27834",
      phone: "(252) 758-6181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles east of Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major eastern NC facility. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "wilson-6",
      name: "Nashville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Washington St",
      city: "Nashville",
      state: "NC",
      zip: "27856",
      phone: "(252) 459-2181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles north of Wilson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Nash County. Alternative for Wilson north side residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Wilson photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wilson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wilson applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wilson County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wilson travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Wilson." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wilson address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Wilson before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Wilson for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Wilson?", a: "Fast Passport Center offers fast passport renewal in Wilson in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Wilson?", a: "The nearest regional passport agency to Wilson is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 270 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Wilson without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Wilson?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Wilson — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wilson County residents." },
    { q: "Do you serve the entire Wilson County area?", a: "Absolutely. Fast Passport Center serves the entire Wilson County area including Wilson, Elm City, Lucama, Saratoga, Black Creek, Stantonsburg, and surrounding communities. We also serve neighboring counties including Nash, Edgecombe, Johnston, Wayne, Pitt, and Greene. Our courier service works seamlessly from any address in the region." },
    { q: "Can I expedite a child passport in Wilson?", a: "Yes. Fast Passport Center expedites child passports in Wilson for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wilson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Wilson with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Wilson", address: "2601 Ward Blvd, Wilson, NC 27893", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wilson", address: "3400 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Wilson", address: "3101 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Rocky Mount", address: "1200 S Wesleyan Blvd, Rocky Mount, NC 27803", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Goldsboro", address: "2205 E Ash St, Goldsboro, NC 27530", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Greenville", address: "2100 E Fire Tower Rd, Greenville, NC 27858", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Smithfield", address: "1230 N Brightleaf Blvd, Smithfield, NC 27577", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Raleigh", address: " Multiple locations", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Wilson",
      address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Rocky Mount",
      address: "1331 S Wesleyan Blvd, Rocky Mount, NC 27803",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Nash and Edgecombe County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Goldsboro",
      address: "2133 E Ash St, Goldsboro, NC 27530",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wayne County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Raleigh",
      address: "4121 New Bern Ave, Raleigh, NC 27610",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Wake County central office. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "55 miles west of Wilson",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for Wilson travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "RWI",
      name: "Rocky Mount-Wilson Airport",
      distance: "15 miles northeast of Wilson",
      address: "500 Airport Rd, Rocky Mount, NC 27804",
      note: "Regional general aviation airport. No commercial passenger service — used for private aviation only.",
      flightUrl: "https://www.rwiairport.com/",
      flightLabel: "RWI Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "200 miles west of Wilson",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Alternative for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Wilson County Register of Deeds", url: "https://www.wilsoncountync.gov/168/Register-of-Deeds", description: "Birth, death, and marriage records for Wilson County" },
    { name: "Wilson County Superior Court", url: "https://www.nccourts.gov/locations/wilson-county", description: "Divorce records and court documents for Wilson County" },
  ],
};